import { TradeIn } from "@carsdotcom/ccdp-sdk/lib/cjs/domains/trade-in";
import { logError } from "src/utils/logger";
import { discardTradeIn, emitTradeIn, fetchLastTradeIn } from "@carsdotcom/ccdp-sdk";
import { Store } from "src/store";
import { getAndPatchTradePendingReportRequest } from "src/store/actions/tradeIn";
import { getVehiclesArrayForFEA } from "src/store/selectors/vehicles";

/**
 * Sync wrappers for the async CCDP TradeIn functions.
 */
export function getTradeInFromCCDP(store: Store) {
    fetchLastTradeIn()
        .then((tradeIn) => {
            if (Object.keys(tradeIn).length > 0) {
                const state = store.getState();
                const partnerId = state.account.integration_settings?.TP_TradeEstimate?.partner_id;

                if (partnerId) {
                    void store.dispatch(
                        getAndPatchTradePendingReportRequest({
                            uuid: state.deal.uuid!,
                            tradeIn,
                            postalCode: state.deal.person?.zip ?? state.account.address?.zip!,
                            partnerId,
                            url: state.account.url ?? "https://dealerinspire.com",
                            vehiclesForFEA: getVehiclesArrayForFEA(state),
                            initiator: "ccdp",
                        })
                    );
                }
            }
        })
        .catch((error) => logError(error));
}

export function saveTradeInToCCDP(data: TradeIn) {
    emitTradeIn(data).catch((error) => logError(error));
}

export function removeTradeInFromCCDP() {
    discardTradeIn().catch((error) => logError(error));
}
